import DocumentCategoryService from 'src/modules/documentCategory/documentCategoryService';
import Errors from 'src/modules/shared/error/errors';
import {getHistory} from 'src/modules/history';

const prefix = 'DOCUMENT_CATEGORY_VIEW';

const documentCategoryViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: documentCategoryViewActions.FIND_STARTED,
      });

      const record = await DocumentCategoryService.find(id);

      dispatch({
        type: documentCategoryViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: documentCategoryViewActions.FIND_ERROR,
      });

      getHistory().push('/document-category');
    }
  },
};

export default documentCategoryViewActions;
